// extracted by mini-css-extract-plugin
export default {"container":"PersonnelList_container__rB--D","title":"PersonnelList_title__6F+CF","personnelList":"PersonnelList_personnelList__S85vA"};